import React from 'react'
import PropTypes from 'prop-types'
import Slide from './Slide'
import Disclaimer from './Disclaimer'
import Transition from 'react-transition-group/Transition'
import { connect } from 'react-redux'
import { changeActiveSlide, startLang } from '../actions'

import './TitleSlide.css'


class TitleSlide extends Slide {


    constructor(props) {
        super(props)
        this.changeSlide = this.changeSlide.bind(this)
        this.switchLang = this.switchLang.bind(this)
    }

    renderMobile() {

        const defaultStyles = (duration, delay = 300) => ({
            transition: `opacity ${duration}ms ${delay}ms ease-in`
        })

        const transitionStyles = {
            entering: { opacity: 0 },
            entered: { opacity: 1 },
            exiting: { opacity: 1 },
            exited: { opacity: 0 }
        }

        return super.render(
            <Transition in={this.props.in} timeout={0}>
                { state => (
                    <div className='TitleSlide' style={{background: `url(${this.props.background})`}}>
                    <div className='TitleSlide-Header' style={{...defaultStyles(300, 4000), ...transitionStyles[state]}}>
                        <div className='TitleSlide-Credit'>
                            { this.props.credit }
                        </div> 
                        <img className='TitleSlide-Logo' src={this.props.logo}/>
                    </div>
                    <div className='TitleSlide-Main'>
                        <div className='TitleSlide-Title' style={{...defaultStyles(300, 1000), ...transitionStyles[state]}}>
                            { this.props.title }
                        </div>
                        <div className='TitleSlide-Subtitle' style={{...defaultStyles(300, 2000), ...transitionStyles[state]}}>
                            { this.props.subtitle }
                        </div>  
                    </div>
                    <Disclaimer className='TitleSlide-Disclaimer' style={{...defaultStyles(300, 3000), ...transitionStyles[state]}}/>
                    <a className='TitleSlide-Link' href='#' style={{...defaultStyles(300, 4000), ...transitionStyles[state]}} onClick={this.switchLang}>{ this.props.link }</a>
                    <a className='TitleSlide-Down' href='#' onClick={this.changeSlide}><i className="fas fa-chevron-down"></i></a>
                </div>
                )}
            </Transition>
        )

    }

    changeSlide() {
        this.props.changeActiveSlide(2)
    }

    switchLang() {
        if(this.props.lang === 'en') {
            this.props.startLang('fr')
        } else if(this.props.lang === 'fr') {
            this.props.startLang('en')
        }
    }

    render() {

        if(this.props.isMobile) return this.renderMobile()

        const defaultStyles = (duration, delay = 300) => ({
            transition: `opacity ${duration}ms ${delay}ms ease-in`
        })

        const transitionStyles = {
            entering: { opacity: 0 },
            entered: { opacity: 1 },
            exiting: { opacity: 1 },
            exited: { opacity: 0 }
        }

        return super.render(
            <Transition in={this.props.in} timeout={0}>
                { state => (
                    <div className='TitleSlide' style={{background: `url(${this.props.background})`}}>
                        <div className='TitleSlide-Header' style={{...defaultStyles(300, 4000), ...transitionStyles[state]}}>
                            <div className='TitleSlide-Credit'>
                                { this.props.credit }
                            </div> 
                            <img className='TitleSlide-Logo' src={this.props.logo}/>
                        </div>
                        <div className='TitleSlide-Main'>
                            <div className='TitleSlide-Title' style={{...defaultStyles(300, 1000), ...transitionStyles[state]}}>
                                { this.props.title }
                            </div>
                            <div className='TitleSlide-Subtitle' style={{...defaultStyles(300, 2000), ...transitionStyles[state]}}>
                                { this.props.subtitle }
                            </div>  
                        </div>
                        <Disclaimer className='TitleSlide-Disclaimer' style={{...defaultStyles(300, 3000), ...transitionStyles[state]}}/>
                        <a className='TitleSlide-Link' href='#' style={{...defaultStyles(300, 4000), ...transitionStyles[state]}} onClick={this.switchLang}>{ this.props.link }</a>
                        <a className='TitleSlide-Down' href='#' onClick={this.changeSlide}><i className="fas fa-chevron-down"></i></a>
                    </div>
                )}
            </Transition>
        )
    }
}

TitleSlide.propTypes = {
    title: PropTypes.any.isRequired,
    subtitle: PropTypes.any.isRequired,
    background: PropTypes.string.isRequired,
    logo: PropTypes.string.isRequired,
    credit: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    isMobile: PropTypes.bool.isRequired
}

const mapStateToProps = ({ isMobile, lang }) => ({ isMobile, lang })
const mapDispatchToProps = dispatch => ({
    changeActiveSlide: slide => dispatch(changeActiveSlide(slide)),
    startLang: lang => dispatch(startLang(lang)),
})
export default connect(mapStateToProps, mapDispatchToProps)(TitleSlide)


// WEBPACK FOOTER //
// ./src/components/TitleSlide.js